
import React from "react";

const reviews = [
  {
    name: "Shivani",
    city: "Delhi",
    text: "Excellent service and quick response."
  },
  {
    name: "Dheeman",
    city: "Greater Noida",
    text: "Professional technicians and affordable AMC."
  },
  {
    name: "Rashmi",
    city: "Noida",
    text: "Fast installation and great customer support."
  }
];

const Testimonials = () => {
  return (
    <section className="usp-section">
      <div className="container">
        <h2 className="section-title">Happy Customers</h2>

        <div className="row">
          {reviews.map((review, index) => (
            <div className="col-md-4" key={index}>
              <div className="testimonial-card">
                <img src="images/user.png" alt={review.name} />
                <h5>{review.name}</h5>
                <small>{review.city}</small>
                <p>{review.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
